<template>
    <div class="login">
        <h1>New Password</h1>
        <ul v-if="errors.length" class="error">
            <li v-for="error in errors" v-bind:key="error">
                {{ error }}
            </li>
        </ul>
        <div>
            <form
                @submit.prevent="newPassword"
                accept-charset="UTF-8"
                v-if="isInitial || isSaving"
            >
                <p class="error">{{ error }}</p>
                <div>
                    <label for="password">
                        Password
                    </label>
                    <input
                        v-model="password"
                        type="password"
                        id="password"
                        name="password"
                        value
                    />
                    <p>Password must be at least 10 characters long.</p>
                </div>

                <div>
                    <label for="password-confirm">
                        Confirm Password
                    </label>
                    <input
                        v-model="passwordConfirm"
                        type="password"
                        id="passwordConfirm"
                        name="passwordConfirm"
                        value
                    />
                </div>
                <div>
                    <button type="submit" name="button">Set Password</button>
                </div>
            </form>
        </div>
        <div v-if="isFailed">
            You&rsquo;ll need to start over.
            <router-link to="/password/reset">Reset password</router-link>.
        </div>
    </div>
</template>
<script>
const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3

export default {
    data() {
        return {
            password: '',
            passwordConfirm: '',
            token: null,
            error: null,
            errors: [],
            currentStatus: STATUS_INITIAL
        }
    },
    created() {
        this.reset
        this.token = this.$route.params.token
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED
        }
    },
    methods: {
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL
            this.error = null
            this.errors = []
        },
        newPassword() {
            this.error = null
            this.errors = []
            this.currentStatus = STATUS_SAVING

            if (this.password != this.passwordConfirm) {
                this.errors.push('Password confirmation does not match.')
            }
            if (this.password.length < 10) {
                this.errors.push(
                    'Password must be at least 10 characters long.'
                )
            }
            if (this.errors.length > 0) {
                return false
            }
            this.$store
                .dispatch('newPassword', {
                    password: this.password,
                    token: this.token
                })
                .then(() => {
                    this.$router.push({ name: 'sightings' })
                })
                .catch(err => {
                    this.errors.push(err.response.data.message)
                    this.currentStatus = STATUS_FAILED
                })
        }
    }
}
</script>
